import { cents, moneyInput } from '../form';
import type { LineDraft } from './lines';

/** Rescale the current line amounts, so repeated conversion does not compound the exchange rate. */
export function incomingLinesInEuros(lines: LineDraft[], eur: number, currentTotal: number): LineDraft[] {
  if (eur <= 0 || currentTotal <= 0) return lines;
  const items = lines.filter((l) => l.kind === 'item');
  if (items.length === 1 && lines.length === 1 && !Number(items[0]!.vatRate.replace(',', '.'))) {
    return [{ ...items[0]!, quantity: '1', unitPrice: moneyInput(eur) }];
  }
  const factor = eur / currentTotal;
  return lines.map((l) => l.kind === 'item' ? { ...l, unitPrice: moneyInput(Math.round(cents(l.unitPrice) * factor)) }
    : l.mode === 'fixed' ? { ...l, value: moneyInput(Math.round(cents(l.value) * factor)) } : l);
}
